import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("service-detail", {
    model: {
      defaults: {
        components: html`
          <div
            class="container mx-auto px-4 md:px-12 py-12 grid grid-cols-1 lg:grid-cols-3 gap-10"
          >
            <div class="lg:col-span-2 space-y-8">
              <div>
                <h2
                  class="text-[var(--primary)] md:text-2xl text-xl  font-bold uppercase"
                >
                  Ocean Transport
                </h2>
                <h1
                  class="md:text-6xl uppercase text-2xl font-bold text-blue-900 mt-2"
                >
                  Introduction to Ocean Transport
                </h1>
                <p class="mt-4 text-gray-700">
                  Welcome aboard Reliable Cargo, where your logistics needs
                  chart the course, and our ocean transport services steer you
                  towards success. Ocean transport remains the backbone of
                  global trade, offering unmatched scale and efficiency. It’s
                  the lifeline for economies worldwide, including Nepal, and
                  serves as a bridge connecting distant markets with resilience
                  and resilience. Dive into our ocean transport services and
                  discover how we can optimize your logistics from inland to
                  overseas.
                </p>
              </div>

              <div>
                <h2 class="text-2xl uppercase font-bold text-blue-900 mb-2">
                  Overview of Ocean Transport Services
                </h2>
                <p class="text-gray-700">
                  At Reliable Cargo, we provide a vast array of ocean transport
                  solutions designed to meet diverse global shipping needs. From
                  standard container shipments to customized cargo solutions,
                  our services are engineered to ensure efficiency, safety, and
                  cost-effectiveness. Each solution we offer is backed by our
                  commitment to customer satisfaction and tailored to enhance
                  your supply chain.
                </p>
              </div>

              <div>
                <h2 class="text-2xl uppercase font-bold text-blue-900 mb-2">
                  Importance of Ocean Cargo for Nepal
                </h2>
                <p class="text-gray-700">
                  Landlocked yet strategically located, Nepal relies on ocean
                  cargo for access to international markets. Ocean transport is
                  vital for importing essential goods and exporting Nepal’s
                  unique products to the world. Reliable Cargo acts as a crucial
                  conduit, enabling seamless connections to global sea routes
                  and empowering local businesses with global reach.
                </p>
              </div>

              <div>
                <h2 class="text-2xl uppercase  font-bold text-blue-900 mb-2">
                  Services Offered by Reliable Cargo
                </h2>
                <ul class="list-disc list-inside text-gray-700 space-y-2">
                  <li>
                    <strong>Full Container Load (FCL) Shipping:</strong> Ideal
                    for large volumes, FCL provides you with a dedicated
                    container, offering security and exclusivity for your cargo.
                  </li>
                  <li>
                    <strong>Less than Container Load (LCL) Shipping:</strong>
                    Perfect for smaller shipments, LCL allows you to share
                    container space with others, optimizing costs without
                    sacrificing speed.
                  </li>
                  <li>
                    <strong>Specialized Cargo Services:</strong> For cargo that
                    demands special handling, such as refrigerated goods,
                    hazardous materials, or oversized equipment, we have
                    tailored solutions to ensure safety and compliance.
                  </li>
                </ul>
              </div>

              <div>
                <h2 class="text-2xl uppercase  font-bold text-blue-900 mb-2">
                  Advantages of Using Ocean Transport for Cargo
                </h2>
                <ul class="list-disc list-inside text-gray-700 space-y-2">
                  <li>
                    <strong>Cost-Effectiveness:</strong> Typically more
                    economical than air freight, especially for larger and
                    heavier shipments.
                  </li>
                  <li>
                    <strong>Capacity and Flexibility:</strong> Shipping by ocean
                    supports all goods, offering flexibility in load size and
                    type.
                  </li>
                  <li>
                    <strong>Sustainability:</strong> Compared to other transport
                    modes, ocean shipping has a lower carbon footprint per
                    ton-kilometer moved.
                  </li>
                </ul>
              </div>

              <div>
                <h2 class="text-2xl uppercase  font-bold text-blue-900 mb-2">
                  Ocean Transport Process
                </h2>
                <p class="text-gray-700">
                  From standard bookings, Reliable Cargo ensures a smooth ocean
                  transport process. We handle everything from cargo scheduling,
                  port clearance and inland deliveries. Our robust tracking
                  system keeps you informed every step of the way, providing
                  peace of mind and real-time data.
                </p>
              </div>

              <div>
                <h2 class="text-2xl uppercase  font-bold text-blue-900 mb-2">
                  Regulations and Compliance
                </h2>
                <p class="text-gray-700">
                  Our team ensures all shipments adhere to local and
                  international maritime laws and trade regulations. We navigate
                  documentation and customs requirements, ensuring timely and
                  compliant cargo movement.
                </p>
              </div>
              <div>
                <h2 class="text-2xl uppercase font-bold text-blue-900 mb-2">
                  Why Choose Reliable Cargo
                </h2>
                <p class="text-gray-700">
                  Choosing Reliable Cargo means selecting a leader in ocean
                  transport. Our in-depth understanding of logistics, coupled
                  with our strategic approach to ocean shipping, makes us the
                  partner of choice for businesses large and small. With
                  Reliable Cargo, your shipments not only reach their
                  destinations safely; they also propel your business towards
                  greater growth and success.
                </p>
                <p class="text-gray-700 mt-4">
                  By choosing Reliable Cargo for your ocean transport needs,
                  you’re not just selecting a shipping service; you’re aligning
                  with a partner dedicated to your success on the global stage.
                  Our commitment to excellence, combined with our comprehensive
                  range of ocean transport solutions, ensures your cargo is not
                  just transported, but is also cared for as if it were our own.
                  Let Reliable Cargo be your guide and guardian across the seas
                  as you expand your horizons and take your business to new
                  ports. Embrace the journey with Reliable Cargo—where your
                  cargo’s safety, efficiency, and timely delivery are our
                  highest priority.
                </p>
                <p class="text-gray-700 mt-4">
                  These sections are designed to open and close the content on
                  ocean transport with a strong narrative, emphasizing Reliable
                  Cargo’s commitment to providing effective, efficient, and
                  trustworthy service.
                </p>
              </div>
            </div>

            <aside class="space-y-8 sticky top-6 self-start">
              <div class="bg-[#F7F7F7] px-4 py-8">
                <h3 class="text-xl font-bold text-blue-900 border-b pb-2 mb-2">
                  Archives
                </h3>
                <ul class="text-blue-700 space-y-1">
                  <li>• May 2025</li>
                </ul>
              </div>

              <div class="bg-[#F7F7F7] px-4 py-8">
                <h3 class="text-xl font-bold text-blue-900 border-b pb-2 mb-2">
                  Categories
                </h3>
                <ul class="text-blue-700 space-y-1">
                  <li>• Chemistry</li>
                  <li>• Covid Analysis</li>
                  <li>• Forensic science</li>
                </ul>
              </div>
              <div class="bg-[#F7F7F7] px-4 py-8">
                <h3 class="text-xl font-bold text-blue-900 border-b pb-2 mb-2">
                  Our Services
                </h3>
                <ul class="space-y-2">
                  <li>
                    <a
                      href="/air-transport"
                      class="block bg-white text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-4 py-2 rounded font-semibold"
                      >Air Transport</a
                    >
                  </li>
                  <li>
                    <a
                      href="/ocean-transport"
                      class="block bg-white text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-4 py-2 rounded font-semibold"
                      >Ocean Transport</a
                    >
                  </li>
                  <li>
                    <a
                      href="/road-transport"
                      class="block bg-white text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-4 py-2 rounded font-semibold"
                      >Road Transport</a
                    >
                  </li>
                  <li>
                    <a
                      href="/rail-transport"
                      class="block bg-white text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-4 py-2 rounded font-semibold"
                      >Rail Transport</a
                    >
                  </li>
                  <li>
                    <a
                      href="/home-delivery"
                      class="block bg-white text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white px-4 py-2 rounded font-semibold"
                      >Home Delivery</a
                    >
                  </li>
                </ul>
              </div>

              <div class="bg-[#F7F7F7] px-4 py-8">
                <h3 class="text-xl font-bold text-blue-900 border-b pb-2 mb-4">
                  Get a Free Quote
                </h3>
                <form class="space-y-4">
                  <input
                    type="text"
                    placeholder="Enter Full Name"
                    class="w-full border bg-white px-4 py-2 rounded outline-blue-400"
                  />
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    class="w-full border bg-white px-4 py-2 rounded outline-blue-400"
                  />
                  <textarea
                    placeholder="Message"
                    rows="4"
                    class="w-full border bg-white px-4 py-2 rounded outline-blue-400"
                  ></textarea>
                  <button
                    type="submit"
                    class="w-full bg-[var(--primary)] hover:bg-[#FA6914] text-white py-2 rounded font-semibold"
                  >
                    Send
                  </button>
                </form>
              </div>
            </aside>
          </div>
        `,
      },
    },
  });
};
